import { tokens } from '@fluentui/react-components';
import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    container: {
        gridColumn: '1 / -1',
        paddingTop: tokens.spacingVerticalXS,
        backgroundColor: `${tokens.colorTransparentBackground} !important`,
        border: 'none',
    },
    emptyTable: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: tokens.spacingVerticalM,
        top: tokens.spacingVerticalS,
        padding: tokens.spacingVerticalL,
        width: '100%',
        height: '100%',
        fontWeight: tokens.fontWeightSemibold,
        border: [tokens.strokeWidthThin, 'dashed', tokens.colorNeutralStroke1].join(' '),
        borderRadius: tokens.borderRadiusXLarge,
        backgroundColor: tokens.colorNeutralBackground2,
        userSelect: 'none',
        cursor: 'default',
    },
});
